<template>
    <div>
        <h1 class="mb-4 font-active">Payment Options</h1>
        <p>
            Friendly Diamonds offers a variety of payment methods for purchasing lab diamonds and diamond jewellery to provide a smooth and hassle-free buying experience. All prices on our website are in Indian rupees (₹).
        </p>
        <p>
            Customers can choose to pay online, where they can simply pay the full amount in one go with any of the payment modes mentioned below or they pay through a partial Cash on Delivery method, wherein they can pay up to ₹55,000 in cash upon delivery.
        </p>

        <h2 class="mb-0">Modes of Payment</h2>

        <h3>Credit Card & Debit Card</h3>
        <p>
            We accept Visa, MasterCard, American Express and RuPay, as well as other major credit cards & debit cards. If a payment fails, the order will be automatically cancelled. The failure may occur due to insufficient funds in their bank account or if the amount charged exceeds their credit limit. Customers are advised to contact their bank in case their payment is rejected and try again once the bank approves the transaction.

        </p>
        <h3>Net Banking</h3>
        <p>
            Net banking allows the customers to directly pay from their bank account through our secure online platform. Customers can simply select the Net Banking option at checkout and choose their respective bank. They will be redirected to the bank's website where they can log in securely and authorise the payment. <br><br>
            After the transaction is completed, customers will receive the confirmation of their payment. Once the payment is received, we will process the order. Through Net Banking, customers can shop with peace of mind, knowing their transactions are safe and secure.
        </p>
        <h3>UPI</h3>
        <p>
            We also offer hassle-free UPI payment option through applications like GPay, PhonePe and Paytm. With UPI, customers can securely complete their transactions directly from their bank account, without the need to enter card details or navigate through multiple steps. Simply select the UPI option at checkout, enter your UPI ID and complete the transaction with a few taps on your smartphone. It's fast, easy and ensures a flexible experience for our valued customers.
        </p>
        <h3>Partial COD</h3>
        <p>Customers can choose to pay through a partial Cash On Delivery method, wherein they can pay up to ₹55,000 in cash upon delivery alongside a minimum of 10% of the total amount online through any of the different options available for online payment.</p>
        
    </div>
</template>

<script setup>
    
</script>

<style scoped>
.red{
    color: rgb(251, 8, 8);
}
.main_title {
    margin: 4% 0;
}
.main_title h2 {
    font-size: 40px;
    text-align: center;
}
h1{
    font-size: 32px;
    text-transform: capitalize;
}
p {
    margin-bottom: 0;
    color: #606060;
    font-size: 16px;
    font-weight: 500;
}
ul {
    margin-left: 25px;
    padding-left: 0;
}
ul li{
    color: #606060;
    font-size: 16px;
    font-weight: 500; 
}
h2 {
    font-size: 24px;
    font-weight: 500;
    color: #212529;
    margin: 30px 0 20px;
}
h3 {
    font-size: 22px;
    font-weight: 500;
    color:#353535;
    margin: 30px 0 20px;
}
h4{
    margin-bottom: 6px;
    color: #353535;
    font-size: 16px;
    font-weight: 600;
    line-height: 1.5;
}
a{
    color: var(--green);
    text-decoration: underline;
}


@media(max-width: 767px){
    .main_title h2{
        font-size: 32px;
    }
    .main_title {
        margin: 13% 0 10%;
    }
    h1{
        font-size: 20px;
    }
    h2{
        font-size: 18px;
    }
    h3 {
        font-size: 16px;
    }
    p {
        font-size: 14px;
    }
    ul li {
        font-size: 14px;
    }
}
</style>